import * as EmailNotificationActionMetadataKeys from 'automation-ui-action-features/actions/email-notification/EmailNotificationActionMetadataKeys';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { clean } from 'automation-ui-action-features/utils/sanitize';
import { Map as ImmutableMap, List, Record } from 'immutable';
export default class EmailNotificationActionMetadata extends Record({
  [EmailNotificationActionMetadataKeys.ACTION_TYPE]: ActionTypes.EMAIL_NOTIFICATION,
  [EmailNotificationActionMetadataKeys.SUBJECT]: null,
  [EmailNotificationActionMetadataKeys.BODY]: null,
  [EmailNotificationActionMetadataKeys.EMAIL_ADDRESSES]: null,
  [EmailNotificationActionMetadataKeys.TEAM_IDS]: null,
  [EmailNotificationActionMetadataKeys.USER_IDS]: null,
  [EmailNotificationActionMetadataKeys.OWNER_PROPERTIES]: null
  // To be supported in future version
  // [EmailNotificationActionMetadataKeys.OWNER_IDS]: null,
}, 'EmailNotificationActionMetadata') {
  constructor(props) {
    let propMap = ImmutableMap(props || {});
    if ((props === null || props === void 0 ? void 0 : props.body) != null) {
      propMap = propMap.set('body', clean(props.body, undefined, undefined, false));
    }
    super(propMap);
  }
  getTeamIds() {
    const teamIds = this.get(EmailNotificationActionMetadataKeys.TEAM_IDS);
    return teamIds !== null ? List(teamIds) : List();
  }
  getUserIds() {
    const userIdsValue = this.get(EmailNotificationActionMetadataKeys.USER_IDS);
    const userIds = userIdsValue !== null ? List(userIdsValue) : List();
    return userIds.map(userId => `${userId}`);
  }
  getOwnerProperties() {
    const ownerProperties = this.get(EmailNotificationActionMetadataKeys.OWNER_PROPERTIES);
    return ownerProperties !== null ? List(ownerProperties) : List();
  }
}